/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Guide_Stat_3_LabelInputs */

const en_landing_guide_stat_3_label = /** @type {(inputs: Landing_Guide_Stat_3_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untouched pixels kept identical per edit`)
};

const zh_landing_guide_stat_3_label = /** @type {(inputs: Landing_Guide_Stat_3_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每轮编辑未修改像素保持一致`)
};

/**
* | output |
* | --- |
* | "Untouched pixels kept identical per edit" |
*
* @param {Landing_Guide_Stat_3_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_guide_stat_3_label = /** @type {((inputs?: Landing_Guide_Stat_3_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Guide_Stat_3_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_guide_stat_3_label(inputs)
	return zh_landing_guide_stat_3_label(inputs)
});
export { landing_guide_stat_3_label as "landing.guide.stat_3_label" }